import BasicLinkComponent from 'components/common/Link';
import ButtonComponent from 'components/common/Button';

function ProductItemButton({ button }: Readonly<{ button: any }>) {
  const buttonLinkURL =
    (button?.buttonPageSlug?.slug && `/${button.buttonPageSlug.slug}`) ||
    button?.buttonUrl;

  return (
    <div className="flex-auto w-full">
      {button && buttonLinkURL && (
        <div className="w-full mt-[10px]">
          <BasicLinkComponent
            href={buttonLinkURL}
            rel={button.buttonLinkRel}
            isExternalLink={!!button.buttonUrl}
            className="block text-center !leading-1 h-[38px] rounded-[6px] text-[16px]"
            useUTMParams={button?.useUTMParams || false}
          >
            <ButtonComponent
              {...button}
              isFullWidth
              btnStyle="h-[2.375rem] p-[0.532rem] rounded-[0.375rem]"
            />
          </BasicLinkComponent>
        </div>
      )}
    </div>
  );
}

export default ProductItemButton;
